<template>
  <div style="display:inline-block;padding: 26px;">
    <a-button @click="handleOpen">
      <a-icon type="upload" />上传公开图片到Hbase
    </a-button>
    <a-button @click="handleOpenDoc">
      <a-icon type="upload" />上传公开文件到Hbase
    </a-button>
    <a-modal
      v-model="visible"
      title="上传公开图片到Hbase"
      @cancel="handleCancel"
      @ok="handleOk"
      :okText="okText"
      :destroyOnClose="true"
    >
      <upload-handly
        accept=".jpg,.jpeg,.png"
        :fileList="fileList"
        @onChange="handleFileChange"
      />
      <p style="margin-top: 16px;">
        <span v-if="cdnUrl">线上CDN地址：</span>
        {{ cdnUrl }}
      </p>
    </a-modal>
    <a-modal
      v-model="visibleDoc"
      title="上传公开文件到Hbase"
      @cancel="handleCancelDoc"
      @ok="handleOkDoc"
      :okText="okText"
      :destroyOnClose="true"
    >
      <upload-handly :fileList="fileListDoc" @onChange="handleFileChangeDoc" />
      <p style="margin-top: 16px;">
        <span v-if="cdnUrlDoc">线上CDN地址：</span>
        {{ cdnUrlDoc }}
      </p>
    </a-modal>
  </div>
</template>
<script>
import axios from 'axios'
import { UploadHandly } from '@/components/Upload'
import { copyData } from '@/service/common'
const imgUrl = 'https://gallery.yuanfudao.com/api/tutor/images'
const docUrl = 'https://gallery.yuanfudao.com/api/tutor/resources'
// const imgUrl = 'http://ytkgallery.yuanfudao.ws/api/tutor/images'
export default {
  components: { UploadHandly },
  data() {
    return {
      imgUrl,
      fileList: [],
      fileListDoc: [],
      visible: false,
      visibleDoc: false,
      cdnUrl: '',
      cdnUrlDoc: '',
      okText: '上传',
    }
  },
  methods: {
    handleOpen() {
      this.fileList = []
      this.visible = true
    },
    handleOpenDoc() {
      this.fileListDoc = []
      this.visibleDoc = true
    },
    handleCancel() {
      this.fileList = []
      this.visible = false
    },
    handleCancelDoc() {
      this.fileListDoc = []
      this.visibleDoc = false
    },
    handleFileChange(value) {
      this.fileList = value
    },
    handleFileChangeDoc(value) {
      this.fileListDoc = value
    },
    handleOk() {
      if (this.okText === '上传') {
        this.handleUpload()
      } else {
        copyData(this.cdnUrl)
      }
    },
    handleOkDoc() {
      if (this.okText === '上传') {
        this.handleUploadDoc()
      } else {
        copyData(this.cdnUrlDoc)
      }
    },
    async handleUpload() {
      const formData = new FormData()
      // for (let i = 0; i < this.fileList.length; i++) {
      //   formData.append('images', this.fileList[i])
      // }
      formData.append('image', this.fileList[0])
      try {
        const imgInfo = await axios.post(imgUrl, formData)
        this.cdnUrl = `${imgUrl}/${imgInfo.imageId}`
        this.okText = '复制链接'
      } catch {}
    },
    async handleUploadDoc() {
      const formData = new FormData()
      formData.append('resource', this.fileListDoc[0])
      try {
        const docInfo = await axios.post(docUrl, formData)
        this.cdnUrlDoc = `${docUrl}/${docInfo.resourcesId}`
        this.okText = '复制链接'
      } catch {}
    },
  },
}
</script>
<style lang="less" scoped></style>
